<template>
  <delegation-order-form ref="delegationOrderForm" />
</template>

<script>
import DelegationOrderForm from "../../components/DelegationOrder/DelegationOrderForm";
export default {
  name: "DelegationOrderEditView",
  components: { DelegationOrderForm },
  beforeRouteLeave(from, to, next) {
    this.$refs.delegationOrderForm.beforeRouteLeave(from, to, next);
  },
  mounted() {
    this.$store.commit("DelegationOrder/setReadonly", true);
  },
  beforeDestroy() {
    this.$store.commit("DelegationOrder/setReadonly", false);
  }
};
</script>

<style scoped></style>
